module.exports = __webpack_public_path__ + "static/media/IconWallet.b1857340.svg";